// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"221":"9e57bf17","239":"26c99017","453":"117b0875","732":"3b14ac7e","977":"ea52e03c"}[chunkId] + ".chunk.js";
};